module.exports = __webpack_public_path__ + "static/media/peroni3.5.c09cc004.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni3.5.png
// module id = 811
// module chunks = 0